<template>
  <div
    class="biz-selector-content border-primary-6"
    :class="{'disabled':disabled}"
  >
    <div
      v-if="!singleCloseable&&value[labelKey]"
      class=""
    >
      {{ value[labelKey] || '' }}
    </div>
    <div v-else-if="value[labelKey]">
      <yxt-tag
        type="info"
        :size="size"
        closable
        @close="deleteTag"
      >
        {{ value[labelKey] }}
        <template v-if="value.includeAll">
          {{ $t('pc_gwnl_selectOuter_group_lbl_includeAll') }}
        </template>
      </yxt-tag>
    </div>
    <div v-else-if="defaultTag">
      <yxt-tag
        type="info"
        :size="size"
        closable
        @close="deleteTag"
      >
        {{ defaultTag }}
      </yxt-tag>
    </div>
    <div v-else>
      <div class="color-gray-6 standard-size-14 mt1">
        {{ placeholder }}
      </div>
    </div>
    <yxt-svg
      class="biz-selector-content__icon color-gray-6 hover-primary-6"
      width="28px"
      height="28px"
      icon-class="three-dot"
    />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return [];
      }
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    singleCloseable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    defaultTag: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    deleteTag() {
      this.$emit('change', {});
    }
  }
};
</script>
